module.exports = __webpack_public_path__ + "media/images/admin/icons/refresh-cw-7880f832e9f84ceda94da61c5cecbd1f.svg";